import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetPlayerYearlyStatistics = () => {
    const send = useGenericSend();

    return useCallback(async ({ year }: Types.IGetPlayerYearlyStatisticsRequestData) => {
        const { data } = await send<Types.IGetPlayerYearlyStatisticsRequestData, Types.IGetPlayerYearlyStatisticsResponseData>({
            ID: 32029,
            responses: [32030, 32031],
            description: 'Get Player Yearly Statistics',
            year
        });

        return data;
    }, [send]);
};
